import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { ChevronDownSvg } from "../../svgFiles/ChevronDownSvg";
import { getClassByType } from "../../helpers/Utils";

const Orderstatus = ({
  value,
  onSelect,
  statusesOptions = [],
  label,
  disabled = false,
  className
}) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (value !== undefined && statusesOptions.length > 0) {
      const found = statusesOptions.find((s) => s.value === String(value));
      setSelected(found || null);
    } else {
      setSelected(null);
    }
  }, [value, statusesOptions]);

  const statusChange = selected ? getClassByType(selected.value) : { class: "" };

  const renderSelected = () => {
    if (label && !selected) {
      return <span>{label}</span>;
    }
    if (selected) {
      return (
        <span>
          {label ? (
            <span className="me-1">{label} :</span>
          ) : null}
          <span
            className={`${statusChange.class} status-badge d-flex justify-content-between align-items-center`}
          >
            {selected.code}
            <span className="bar me-2">{selected.label}</span>
            <ChevronDownSvg />
          </span>
        </span>
      );
    }
    return <span>Change Status</span>;
  };

  return (
    <Dropdown
      className={`${statusChange.class} ${className} custoom-dropdown w-100 statusDrop${disabled ? " is-disabled" : ""}`}
    >
      <Dropdown.Toggle
        disabled={disabled}
        id="custom-dropdown"
        variant="unset"
        className="d-flex justify-content-between align-items-center w-100"
        style={disabled ? { cursor: "not-allowed" } : undefined}
      >
        {renderSelected()}
        {!className && <ChevronDownSvg />}
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100">
        {statusesOptions.map((status) => {
          const statusChange = getClassByType(status.value);
          return (
            <Dropdown.Item
              key={status.code}
              onClick={() => onSelect(status.value)} // auto closes
              active={selected?.code === status.code}
            >
              <span className={`${statusChange.class} status-badge`}>
                {status.code}
                <span className="bar">{status.label}</span>
              </span>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Orderstatus;
